import React from "react";

function KeyValueList({ items = [], className = "" }) {
  const classes = ["ui-key-value-list", className].filter(Boolean).join(" ");

  return (
    <dl className={classes}>
      {items.map((item, index) => (
        <div className="ui-key-value-list__row" key={item.key || index}>
          <dt className="ui-key-value-list__label">{item.label}</dt>
          <dd className="ui-key-value-list__value" title={item.title || ""}>
            {item.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}

export default KeyValueList;
